import axios from "axios";
import { getTokenFromStorage } from "../utils/localStorage";
import { clearSessionAndRedirect } from "./httpConfig";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getTokenFromStorage();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Mirror the global 401 handling (Dag 7): an expired/invalid token clears the
// session and returns the user to login instead of leaving a broken view.
axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      clearSessionAndRedirect();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
